import { Component, EventEmitter, Output } from '@angular/core';
import { NgScrollbarModule } from 'ngx-scrollbar';
import { NgScrollReachDrop } from 'ngx-scrollbar/reached-event';

@Component({
  selector: 'korviu-scrollbar',
  standalone: true,
  imports: [NgScrollbarModule, NgScrollReachDrop],
  templateUrl: './korviu-scrollbar.component.html',
  styleUrls: ['./korviu-scrollbar.component.scss']
})
export class KorviuScrollbarComponent {
  @Output() reachedBottom: EventEmitter<void>;

  constructor() {
    this.reachedBottom = new EventEmitter<void>();
  }

  onReachedBottom(): void {
    this.reachedBottom.emit();
  }
}
